// Tells the server, in the background, that something happened that only the browser sees (a favourite,
// a share, a search). The server keeps anonymous per-day totals; nothing about the visitor is sent.
export function ping(kind, data = {}) {
  if (!navigator.sendBeacon) return

  const body = new FormData()
  body.append("kind", kind)
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token) body.append("authenticity_token", token)
  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined && value !== null && value !== "") body.append(key, value)
  }
  navigator.sendBeacon("/pings", body)
}
